import { store } from "@/store/store";
import constants from "@/config/constants";
const blockEvents = () => {
  const isBlockedDomain = constants.blockEmailDomains.some(item =>
    store.state.auth.user.email.includes(item)
  );

  const isBlockedEmailAddress = constants.blockedEmailAddresses.some(
    item => store.state.auth.user.email === item
  );

  const isTrackingDisabled =
    window.navigator.doNotTrack ||
    window.doNotTrack ||
    window.navigator.msDoNotTrack;

  return isTrackingDisabled || isBlockedDomain || isBlockedEmailAddress;
};

export default blockEvents;
